/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerExperienceType } from './PartnerExperienceType';
import {
    PartnerExperienceTypeFromJSON,
    PartnerExperienceTypeFromJSONTyped,
    PartnerExperienceTypeToJSON,
    PartnerExperienceTypeToJSONTyped,
} from './PartnerExperienceType';
import type { PartnerThemeTokens } from './PartnerThemeTokens';
import {
    PartnerThemeTokensFromJSON,
    PartnerThemeTokensFromJSONTyped,
    PartnerThemeTokensToJSON,
    PartnerThemeTokensToJSONTyped,
} from './PartnerThemeTokens';
import type { PartnerAuthMode } from './PartnerAuthMode';
import {
    PartnerAuthModeFromJSON,
    PartnerAuthModeFromJSONTyped,
    PartnerAuthModeToJSON,
    PartnerAuthModeToJSONTyped,
} from './PartnerAuthMode';

/**
 * 
 * @export
 * @interface PartnerServiceBody
 */
export interface PartnerServiceBody {
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    utmSource?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    gameIdField?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    oAuthClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    logoAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    headerBgAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    brandColor?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    tagline?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartnerServiceBody
     */
    loginBenefits?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PartnerServiceBody
     */
    welcomeEmailTemplateId?: string;
    /**
     * 
     * @type {PartnerAuthMode}
     * @memberof PartnerServiceBody
     */
    authMode?: PartnerAuthMode;
    /**
     * 
     * @type {PartnerThemeTokens}
     * @memberof PartnerServiceBody
     */
    themeTokens?: PartnerThemeTokens;
    /**
     * 
     * @type {Array<PartnerExperienceType>}
     * @memberof PartnerServiceBody
     */
    enabledExperiences?: Array<PartnerExperienceType>;
}



/**
 * Check if a given object implements the PartnerServiceBody interface.
 */
export function instanceOfPartnerServiceBody(value: object): value is PartnerServiceBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PartnerServiceBodyFromJSON(json: any): PartnerServiceBody {
    return PartnerServiceBodyFromJSONTyped(json, false);
}

export function PartnerServiceBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerServiceBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'utmSource': json['utmSource'] == null ? undefined : json['utmSource'],
        'referralCode': json['referralCode'] == null ? undefined : json['referralCode'],
        'gameIdField': json['gameIdField'] == null ? undefined : json['gameIdField'],
        'oAuthClientId': json['oAuthClientId'] == null ? undefined : json['oAuthClientId'],
        'logoAssetId': json['logoAssetId'] == null ? undefined : json['logoAssetId'],
        'headerBgAssetId': json['headerBgAssetId'] == null ? undefined : json['headerBgAssetId'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'tagline': json['tagline'] == null ? undefined : json['tagline'],
        'loginBenefits': json['loginBenefits'] == null ? undefined : json['loginBenefits'],
        'welcomeEmailTemplateId': json['welcomeEmailTemplateId'] == null ? undefined : json['welcomeEmailTemplateId'],
        'authMode': json['authMode'] == null ? undefined : PartnerAuthModeFromJSON(json['authMode']),
        'themeTokens': json['themeTokens'] == null ? undefined : PartnerThemeTokensFromJSON(json['themeTokens']),
        'enabledExperiences': json['enabledExperiences'] == null ? undefined : ((json['enabledExperiences'] as Array<any>).map(PartnerExperienceTypeFromJSON)),
    };
}

export function PartnerServiceBodyToJSON(json: any): PartnerServiceBody {
    return PartnerServiceBodyToJSONTyped(json, false);
}

export function PartnerServiceBodyToJSONTyped(value?: PartnerServiceBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'utmSource': value['utmSource'],
        'referralCode': value['referralCode'],
        'gameIdField': value['gameIdField'],
        'oAuthClientId': value['oAuthClientId'],
        'logoAssetId': value['logoAssetId'],
        'headerBgAssetId': value['headerBgAssetId'],
        'brandColor': value['brandColor'],
        'tagline': value['tagline'],
        'loginBenefits': value['loginBenefits'],
        'welcomeEmailTemplateId': value['welcomeEmailTemplateId'],
        'authMode': PartnerAuthModeToJSON(value['authMode']),
        'themeTokens': PartnerThemeTokensToJSON(value['themeTokens']),
        'enabledExperiences': value['enabledExperiences'] == null ? undefined : ((value['enabledExperiences'] as Array<any>).map(PartnerExperienceTypeToJSON)),
    };
}

